<template>
  <div>
    <b-form-group label="Province" label-for="Provinsi">
        <v-select
          id="provinsi"
          label="name"
          class="style-chooser"
          v-model="form.provinsi"
          :options="option.provience"
          :reduce="(option) => option.name"
          placeholder="Pilih Provinsi"
          :clearable="false"
          :disabled="checked"
          @input="(e) => onSelect(e, 'provinsi')"
        ></v-select>
    </b-form-group>
    <b-form-group label="City" label-for="Kota">
      <v-select
          id="Kota"
          label="name"
          v-model="form.kabupaten"
          :options="option.cities"
          :reduce="(option) => option.name"
          :placeholder="form.kecamatan ? 'Pilih Kabupaten':'Pilih Provinsi Terlebih Dahulu'"
          :clearable="false"
          :disabled="checked || this.loadingKota || !form.provinsi"
          @input="(e) => onSelect(e, 'kabupaten')"
        ></v-select>
    </b-form-group>
    <b-form-group label="Dictrict" label-for="Kecamatan">
      <v-select
          id="Kecamatan"
          label="name"
          v-model="form.kecamatan"
          :options="option.districts"
          :reduce="(option) => option.name"
          :placeholder="form.kabupaten ? 'Pilih Kecamatan':'Pilih Kabupaten Terlebih Dahulu'"
          :clearable="false"
          :disabled="checked || this.loadingKecamatan || !form.kabupaten"
          @input="(e) => onSelect(e, 'kecamatan')"
        ></v-select>
    </b-form-group>
    <b-form-group label="Village" label-for="Kelurahan">
      <v-select
          id="Kecamatan"
          label="name"
          v-model="form.kelurahan"
          :options="option.districts"
          :reduce="(option) => option.name"
          :placeholder="form.kecamatan ? 'Pilih Kelurahan':'Pilih Kecamatan Terlebih Dahulu'"
          :clearable="false"
          :disabled="checked || this.loadingKelurahan || !form.kecamatan"
        ></v-select>
    </b-form-group>
    <b-form-group label="Postal Code" label-for="kode_pos">
      <b-form-input
        id="kode_pos"
        style="height: 35px"
        type="number"
        name="kode_pos"
        :disabled="checked"
        v-model="form.kode_pos"
        @keydown="checkKeyNumber"
        
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Address"
      label-for="alamat_domisili"
    >
      <b-form-textarea
        id="alamat_domisili"
        name="alamat_domisili"
        rows="1"
        v-model="form.alamat"
        :disabled="checked"
        
        placeholder="Alamat..."
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>
<script>
import optionsData from '@src/core/mock/data'
import { crewingActions } from '@src/Utils/helper'

export default {
  name: 'FormInputAddress',
  data() {
    return {
      ...optionsData,
      _loading: false,
      loadingProvinsi: false,
      loadingKota: false,
      loadingKecamatan: false,
      loadingKelurahan: false,
      option: {
        provience: [],
        cities: [],
        districts: [],
        villages: [],
      },
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          provinsi: null,
          kabupaten: null,
          kecamatan: null,
          kelurahan: null,
          kode_pos: 0,
          alamat: '',
        }
      },
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    checked: {
      handler(n, o) {
        this.fetchOptions()
      },
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    ...crewingActions,
    checkKeyNumber(event) {
      const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
      if (!allowedKeys.includes(event.key) && !/^[0-9]$/.test(event.key)) {
        event.preventDefault(); // Prevent non-numeric input and numbers below 0
      }
    },
    async fetchProvinsi() {
      this._loading = true
      let res = await this.fetchProvience()

      if (res.status) {
        if (res.data && res.data.length > 0) {
          res.data.map((state) => {
            this.option.provience.push({
              id: state.id,
              name: state.name,
            })
          })
          this._loading = false
        }
      }

      this._loading = false
    },
    async fetchKota(id) {
      this.loadingKota = true
      let method = 'fetchCities'

      const { data } = await this[method]({ id: id })
      this.option.cities = []
      this.option.districts = []
      this.option.villages = []

      for (const property in data) {
        this.option.cities.push({
          id: property,
          name: data[property],
        })
      }

      this.loadingKota = false
    },
    async fetchKecamatan(id) {
      this.loadingKecamatan = true
      let method = 'fetchDistricts'

      const { data } = await this[method]({ id: id })
      this.option.districts = []
      this.option.villages = []
      for (const property in data) {
        this.option.districts.push({
          id: property,
          name: data[property],
        })
      }

      this.loadingKecamatan = false
    },
    async fetchKelurahan(id) {
      this.loadingKelurahan = true
      let method = 'fetchVillages'

      const { data } = await this[method]({ id: id })
      this.option.villages = []
      for (const property in data) {
        this.option.villages.push({
          id: property,
          name: data[property],
        })
      }

      this.loadingKelurahan = false
    },
    onSelect(e, name) {
      if (name == 'provinsi') {
        const { id } = this.option.provience.find((el) => el.name === e)
        this.fetchKota(id)
      }
      if (name == 'kabupaten') {
        const { id } = this.option.cities.find((el) => el.name === e)
        this.fetchKecamatan(id)
      }
      if (name == 'kecamatan') {
        const { id } = this.option.districts.find((el) => el.name === e)
        this.fetchKelurahan(id)
      }
    },
    async fetchOptions() {
      if (this.value.provinsi) {
        const { id } = this.option.provience.find(
          (el) => el.name === this.value.provinsi
        )
        await this.fetchKota(id)
      }
      if (this.value.kabupaten) {
        const { id } = this.option.cities.find(
          (el) => el.name === this.value.kabupaten
        )
        await this.fetchKecamatan(id)
      }
      if (this.value.kecamatan) {
        const { id } = this.option.districts.find(
          (el) => el.name === this.value.kecamatan
        )
        await this.fetchKelurahan(id)
      }
    },
  },
  async mounted() {
    await this.fetchProvinsi()
    this.fetchOptions()
  },
}
</script>
